<template lang='pug'>
  v-container
    v-card.full-width.mb-4
      v-card-title.text-h5.font-weight-light Profile Information
      v-card-text
        v-row
          v-col(cols='12' sm='6')
            v-text-field(label='First Name' prepend-icon='person' v-model='firstName' required type='text')
          v-col(cols='12' sm='6')
            v-text-field(label='Last Name' prepend-icon='keyboard_arrow_right' v-model='lastName' required type='text')
        v-text-field(label='Email' prepend-icon='email' v-model='email' :disabled='true' type='email')
    v-card.full-width.mb-4
      v-card-title.text-h5.font-weight-light Settings
      v-card-text
        v-select(v-model='rowsPerPage' :items='rowsPerPageOptions' label='Default Rows Per Page')
        v-select(v-if='false' v-model='defaultDashboardView' :items='defaultDashboardViewOptions' item-text='text' item-value='value' label='Default Dashboard View')
    form#changePassword(@submit.prevent='changePassword').full-width.mb-4
      v-card
        v-card-title.text-h5.font-weight-light Change Password
        v-card-text
          v-text-field(prepend-icon='lock'
            label='Current Password'
            v-model='currentPassword'
            min='8'
            :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
            @click:append="hidePassword = !hidePassword"
            :type="hidePassword ? 'password' : 'text'"
            required)
          v-text-field(prepend-icon='lock'
            label='New Password'
            v-model='newPassword'
            min='8'
            :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
            @click:append="hidePassword = !hidePassword" :type="hidePassword ? 'password' : 'text'"
            required)
          v-text-field(label='Confirm Password'
            :prepend-icon="(newPassword === confirmPassword) ? 'check' : 'keyboard_arrow_right'"
            v-model='confirmPassword'
            min='8'
            :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
            @click:append="hidePassword = !hidePassword"
            :type="hidePassword ? 'password' : 'text'"
            required)
        v-card-actions
          v-spacer
          v-btn(text color='primary' form='changePassword' type='submit' :loading='changingPassword') Change Password
</template>

<script>
import _ from 'lodash';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import {createHelpers} from 'vuex-map-fields';
import Notifications from '../../services/notification.service';
import User from '../../api/user';
import SaveMixin from '../../mixins/save.mixin';

// We're using the same getter and mutation types
// as we've used in the store above.
const {mapFields} = createHelpers({
  getterType: 'getUserField',
  mutationType: 'updateUserField'
});

export default {
  name: 'Profile',
  async mounted() {
    await this.getUser();
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount',
      dirty: 'isUserDirty'
    }),
    ...mapFields({
      firstName: 'user.firstName',
      lastName: 'user.lastName',
      email: 'user.email',
      rowsPerPage: 'user.settings.rowsPerPage',
      defaultDashboardView: 'user.settings.defaultDashboardView'
    })
  },
  mixins: [SaveMixin],
  methods: {
    async changePassword() {
      if (this.newPassword !== this.confirmPassword) {
        return Notifications.alert('Passwords do not match.');
      }
      if (this.newPassword.length < 8) {
        return Notifications.alert('Passwords must be at least 8 characters.');
      }
      try {
        this.changingPassword = true;
        await User.changePassword(this.currentPassword, this.newPassword);
        this.currentPassword = null;
        this.newPassword = null;
        this.confirmPassword = null;
        Notifications.toast('Password Changed Successfully');
      } catch (e) {
        this.error(e);
      } finally {
        this.changingPassword = false;
      }
      return true;
    },
    async save() {
      try {
        await this.updateUser();
        Notifications.toast('Saved Successfully');
      } catch (error) {
        console.error(`Error saving profile: ${error.message}`);
        Notifications.errorToast('There was a problem saving', {duration: 30000, retry: this.save});
      }
    },
    error(err) {
      if (_.get(err, 'response.data.message') === 'PASSWORD_INVALID') {
        return Notifications.alert('Incorrect Current Password.');
      }
      console.error('An exception occurred:');
      console.error(err);
      console.error(err.response);
      return err;
    },
    ...mapActions({updateUser: 'updateUser', getUser: 'getUser'}),
    ...mapMutations({clearDirty: 'clearUserDirty'})
  },
  data() {
    return {
      rowsPerPageOptions: [5, 10, 20, 50, 100],
      defaultDashboardViewOptions: [{text: 'Tiles', value: 'TILE'}, {text: 'List', value: 'LIST'}],
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      hidePassword: true,
      changingPassword: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
